import React, { createContext, useContext, useMemo } from "react";

import PropTypes from "prop-types";

const DataLayerContext = createContext({});

export const useDataLayer = () => useContext(DataLayerContext);

function DataLayerProvider(props) {
  const { children } = props;

  let dataLayer = [];

  if (typeof window !== "undefined") {
    dataLayer = window.dataLayer;
  }

  const pushToDataLayer = (name, params = {}) => {
    if (dataLayer && name) {
      dataLayer.push({ event: name, ...params });
    }
  };

  const context = useMemo(
    () => ({
      pushToDataLayer,
    }),
    [pushToDataLayer]
  );

  return (
    <DataLayerContext.Provider value={context}>
      {children}
    </DataLayerContext.Provider>
  );
}

export default DataLayerProvider;

DataLayerProvider.propTypes = {
  children: PropTypes.node,
};

DataLayerProvider.defaultProps = {
  children: null,
};
